import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/common/Layout';
import Dashboard from './pages/Dashboard';
import EntityListPage from './pages/EntityListPage';
import EntityDetailPage from './pages/EntityDetailPage';
import IngestionPage from './pages/IngestionPage';
import ConflictsPage from './pages/ConflictsPage';
import DataSourcesPage from './pages/DataSourcesPage';
import PossibleMatchesPage from './pages/PossibleMatchesPage';
import AdjudicationPage from './pages/AdjudicationPage';
import LoginPage from './pages/LoginPage';
import LandingPage from './pages/LandingPage';
import { useAuth } from './contexts/AuthContext';

// Protected route wrapper
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function App() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LandingPage />} />
      <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />} />

      {/* Protected routes */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Layout><Dashboard /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/entities" element={
        <ProtectedRoute>
          <Layout><EntityListPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/entities/:entityId" element={
        <ProtectedRoute>
          <Layout><EntityDetailPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/ingestion" element={
        <ProtectedRoute>
          <Layout><IngestionPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/conflicts" element={
        <ProtectedRoute>
          <Layout><ConflictsPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/possible-matches" element={
        <ProtectedRoute>
          <Layout><PossibleMatchesPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/adjudication" element={
        <ProtectedRoute>
          <Layout><AdjudicationPage /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/data-sources" element={
        <ProtectedRoute>
          <Layout><DataSourcesPage /></Layout>
        </ProtectedRoute>
      } />
    </Routes>
  );
}

export default App;
